import { Chapter, storyBlocksProps } from "../componentTypes/storyModule";

export const navigateToStoryBreakScreen = (
  navigation: any,
  storyDataArray: any,
) => {
  console.log(
    storyDataArray?.data?.documentId,
    "storyDataArray?.data?.documentId",
  );
  console.log(storyDataArray?.data?.storyId, "storyDataArray?.data?.storyId");
  //   navigation.navigate(SCREENS.ApplicationNavigatorStack, {
  //     screen: SCREENS.StoryBreakScreen,
  //     params: {
  //       milestoneData:
  //         storyDataArray?.data?.milestones[
  //           storyDataArray?.data?.milestones.length - 1
  //         ],
  //       bgImage: storyDataArray?.data?.blocks[0]?.bgImage,
  //       documentId: storyDataArray?.data?.documentId,
  //     },
  //   });
};

export function isLastBlockPending(chapters: Chapter[]): boolean {
  // Define valid statuses for the last block
  // 'running', 'restart', 'restarted' are considered valid for the last block
  // 'pending' is the status we are checking for the last block
  // 'completed' is the status we are checking for all previous blocks
  // 'skipped' is not considered valid for the last block
  const validStatuses = ["running", "restart", "restarted"];

  let previousBlockStatus: string | null = null;
  if (chapters && chapters?.length > 0) {
    for (const chapter of chapters) {
      const blockCount = chapter.blocks.length;

      // Case 1: Last block is pending and all previous are completed
      if (validStatuses.includes(chapter.status) && blockCount > 0) {
        const lastIndex = blockCount - 1;
        const lastBlock = chapter.blocks[lastIndex];

        // Store the last block status of the previous chapter for the next loop iteration
        if (lastIndex >= 0) {
          previousBlockStatus = lastBlock.status;
        }

        if (lastBlock.status !== "pending") continue;

        const othersCompleted = chapter.blocks
          .slice(0, lastIndex)
          .every((block) => block.status === "completed");

        if (othersCompleted) {
          return true;
        }
      }

      // Case 2: Only one block in 'pending', and chapter also in 'pending',
      // and previousBlockStatus is 'completed'
      if (
        blockCount === 1 &&
        chapter.status === "pending" &&
        chapter.blocks[0].status === "pending" &&
        previousBlockStatus === "completed"
      ) {
        return true;
      }

      // Update previousBlockStatus for next iteration
      if (blockCount > 0) {
        previousBlockStatus = chapter.blocks[chapter.blocks.length - 1].status;
      }
    }
  }
  return false;
}

const hasPendingStandardBlock = (
  chapterWithBlock: Chapter,
  blocksDataValue: storyBlocksProps[],
  currentIdx: number,
) => {
  if (
    !chapterWithBlock ||
    !Array.isArray(chapterWithBlock.blocks) ||
    !Array.isArray(blocksDataValue)
  ) {
    return false;
  }

  return chapterWithBlock.blocks.some(
    (block: { id: number; status: string }, index: number) => {
      if (index === currentIdx) return false; // Skip the current block

      const fullBlockData = blocksDataValue.find(
        (item) => item.id === block.id,
      );

      if (!fullBlockData) return false;

      const isPending = block.status?.toLowerCase() === "pending";
      const isStandardBlock =
        fullBlockData.blockType?.toLowerCase() === "standard block";

      return isPending && isStandardBlock;
    },
  );
};

export function hasStandardBlockAfter(
  blocks: storyBlocksProps[],
  chapters: Chapter[],
) {
  const currentIdx = 0;
  if (!Array.isArray(blocks)) {
    return false;
  }
  const currentBlockId = blocks?.[currentIdx]?.id;

  if (blocks?.[currentIdx]?.blockType.toLowerCase() === "re-entry block") {
    return true;
  }

  const chapterWithBlock = chapters?.find((chapter) =>
    chapter?.blocks?.some(
      (block: { id: number }) => block?.id === currentBlockId,
    ),
  );

  let resultValue = null;

  if (chapterWithBlock?.blocks && Array.isArray(chapterWithBlock.blocks)) {
    for (let i = 0; i < chapterWithBlock.blocks.length; i++) {
      if (chapterWithBlock.blocks[i].status === "pending") {
        resultValue = {
          index: i,
          id: chapterWithBlock.blocks[i]?.id,
        };
        break; // terminate the loop
      }
    }
  }

  let result = false;
  if (
    chapterWithBlock &&
    resultValue &&
    typeof resultValue.index === "number"
  ) {
    result = hasPendingStandardBlock(
      chapterWithBlock,
      blocks,
      resultValue.index,
    );
  }

  if (result) {
    return true;
  }

  if (chapterWithBlock) {
    const lastBlock =
      chapterWithBlock.blocks[chapterWithBlock.blocks.length - 1];
    const lastBlockId = lastBlock?.id;
    // Assuming blocks is the array you shared
    const blockWithId = blocks.find((block) => block.id === lastBlockId);
    const blockType = blockWithId ? blockWithId.blockType : null;
    if (blockType?.toLowerCase() === "standard block") {
      return true;
    } else {
      return false;
    }
  }
}

export const handleTemplateFlags = (
  templates: { name: string; status: boolean }[],
  setFlags: any,
) => {
  templates?.forEach(({ name, status }: { name: string; status: boolean }) => {
    if (status) {
      switch (name) {
        case "backPackScreen":
          setFlags.setEnablebagPack(true);
          break;
        case "travelPlan":
          setFlags.setEnableJournal(true);
          break;
        case "wallScreen":
          setFlags.setEnableMywall(true);
          break;
        case "funBoxScreen":
          setFlags.setEnableFunbox(true);
          break;
        case "ballonScreen":
          setFlags.setBallonObject(true);
          break;
        default:
          break;
      }
    }
  });
};

export const conversationBufferDuration = 1000;

export const convertStringToID = (linkTo: string) => {
  // const match = linkTo?.match(/(?<=id:)\d+/);
  // const id = match ? match[0] : null;

  return linkTo.split("id:")[1];
};

export function getRelatedBlockIDs(
  allBlocksData: any[],
  clickedBlockID: number,
) {
  const clickedBlock = allBlocksData.find(
    (block: { id: number }) => block.id === clickedBlockID,
  );
  if (!clickedBlock || !clickedBlock.parentBlock) {
    return []; // No parent block found or the block itself isn't found
  }

  const parentBlockID = clickedBlock.parentBlock.id;
  const blockIDs = allBlocksData
    .filter(
      (block: { parentBlock: { id: number } }) =>
        block.parentBlock && block.parentBlock.id === parentBlockID,
    )
    .map((block: { id: any }) => {
      return {
        id: block.id,
        status: "skipped",
      };
    });
  return [
    ...blockIDs,
    {
      id: parentBlockID,
      status: "completed",
    },
  ];
}

/**
 * Strips the query string from a media URL, leaving only the path that identifies the content.
 * Signed media URLs carry a time-bucketed signature (`?e=...&s=...`) that changes on re-mint
 * even when the underlying file hasn't — use this to derive a content-stable identity for
 * React keys / effect deps instead of keying on the full URL.
 * Assumes the query string is signature-only and never content-differentiating; if the signing
 * service ever adds a query parameter that selects different content, this would need to become
 * an allowlist-strip of just the signature params instead of a blanket strip.
 */
export function stripSignedUrlQuery(url: string): string {
  return url.split("?")[0];
}

/**
 * Extracts the base name (like "home", "book") from a given URL string.
 * Works on a single string or an array of objects containing `url`.
 *
 * @param input - A single URL string OR an array of BlockObject
 * @returns A string (for single URL) or string[] (for array of BlockObject)
 */
export function ExtractNameFromUrl(
  input: string | BlockObject[],
): NameUrl | NameUrl[] {
  const getName = (url: string): string => {
    const fileName = url?.split("/").pop() ?? ""; // e.g. "home_Animation_23f306e8e3.json"
    return fileName?.split("_")[0] || "";
  };

  if (Array.isArray(input)) {
    return input.map((item) => ({
      name: getName(item.url),
      url: item.url,
    }));
  } else {
    return {
      name: getName(input),
      url: input,
    };
  }
}

type BlockObject = {
  linkTo: string;
  url: string;
};

type NameUrl = {
  name: string;
  url: string;
};

/**
 * Returns an array of objects with name and url for all expected names found in blockObjects.
 * If a name is not found, it is not included in the result.
 */
export function getMatchingObjectNames(
  expectedNames: string[],
  blockObjects: BlockObject[],
): NameUrl[] {
  const extractedNames = ExtractNameFromUrl(blockObjects) as NameUrl[];
  return extractedNames[0]?.name
    ? (expectedNames
        ?.map((name) => extractedNames?.find((item) => item.name === name))
        .filter(Boolean) as NameUrl[])
    : [];
}
